<template>
    <div class="row">
        <div class="col-12">
            <div class="card title">
                <div class="card-body title-filter">
                    <div class="row">
                        <div class="col-lg-3 title-filte-left">
                            <h1 class="title-filter-title">
                                <i class="b-table-icon fa fa-cogs"></i>
                                <p class="pl-1">Cài đặt trang chủ</p>
                                <br/>
                                <small>Đường dẫn: <a :href="getLink('/home.html')" target="_blank" >{{getLink('/home.html')}}</a></small>
                            </h1>
                        </div>
                        <div class="col-lg-9 title-filte-right"></div>
                    </div>
                </div>
            </div> 
            <box/>
            <category />
            <news />
            <policy />
        </div>
    </div>
</template>

<script>
    import Box from './Box';
    import Category from './Category';
    import News from './News';
    import Policy from './Policy';
    export default {
        components: {News, Box, Category, Policy},
        methods: {
            getLink(path) {
                return `${this.$store.state.etc['site-frontend-url']}${path}`;
            }
        }
    }
</script>